import IQuestaoDoFormulario from '../interfaces/IQuestaoDoFormulario';
import { CARREGAR_QUESTOES_DO_FORMULARIO } from './actionTypes';

export const carregarQuestoesDoFormulario = (questoesDoFormulario: IQuestaoDoFormulario[]) => {
  return {
    type: CARREGAR_QUESTOES_DO_FORMULARIO,
    state: questoesDoFormulario
  };
};